// src/utils/calculateCommission.js

export const calculateCommission = (totalFacture, rate) => {
    if (totalFacture) {
        const tot = totalFacture * rate / 100;
        return tot;
    }
    return 0;
};
